function Update1() {
    return (<div>Summary 1</div>);
}

export default Update1;